// extracted by mini-css-extract-plugin
export var acitonButtons = "_fy-0";
export var additionalIcon = "_fy-f";
export var block = "_fy-1";
export var blockContent = "_fy-7";
export var blockDescription = "_fy-8";
export var blockIcon = "_fy-9";
export var blockTitle = "_fy-6";
export var border = "_fy-a";
export var center = "_fy-l";
export var edge = "_fy-b";
export var edgeLabel = "_fy-c";
export var edgePath = "_fy-d";
export var error = "_fy-e";
export var flowchart = "_fy-g";
export var flowchartContent = "_fy-h";
export var highlighted = "_fy-3";
export var hover = "_fy-4";
export var icon = "_fy-i";
export var left = "_fy-m";
export var navButton = "_fy-j";
export var navButtons = "_fy-k";
export var right = "_fy-n";
export var selected = "_fy-2";
export var small = "_fy-5";